import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent } from '@material-ui/core';
import * as styles from '../report.module.scss';

interface ConfirmationModalProps {
  open: boolean;
  children: any;
  closeModal: (open: boolean) => void;
  handleOpen?: () => void;
}

const ConfirmationModal = ({ open, closeModal, children, handleOpen }: ConfirmationModalProps) => {
  React.useEffect(() => {
    if (open && handleOpen) {
      handleOpen();
    }
  }, [open]);
  return (
    <Dialog className={styles.dialog} open={open} onClose={closeModal}>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
